import { Box } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { VideoBox } from 'components/common/VideoBox/VideoBox';
import { Z_INDEX } from 'styles/zIndex';
import { getYoutubeEmbedUrl } from 'utils/youtube';

type ArticleVideoProps = {
  rawVideoUrl: string;
  thumbnailUrl?: string;
  description?: string;
  isEmbedded?: boolean;
};

export const ArticleVideo = ({
  rawVideoUrl,
  thumbnailUrl,
  description,
  isEmbedded = false,
}: ArticleVideoProps): ReactElement => {
  const videoUrl = isEmbedded ? getYoutubeEmbedUrl(rawVideoUrl) : rawVideoUrl;

  return (
    <Box
      as="section"
      height="200px"
      background="transparent"
      cursor="pointer"
      display="grid"
      placeItems="center"
      zIndex={Z_INDEX.BASE}
      maxW="100%"
      overflow="hidden"
      my="25px"
    >
      <Box
        position="relative"
        border="default"
        borderColor="border.accent"
        boxSize="175px"
        borderRadius="xl"
        overflow="hidden"
      >
        <VideoBox
          videoUrl={videoUrl}
          isEmbedded={isEmbedded}
          videoDescription={description || 'An explanation video'}
          thumbnailUrl={thumbnailUrl}
        />
      </Box>
    </Box>
  );
};
